import type { AvailabilityUserFiltersValue } from '@epilot/journey-logic-commons/src/services/address-suggestions-service'
import { availabilityCheck } from '@epilot/journey-logic-commons/src/services/address-suggestions-service'
import {
  AVAILABILITY_CHECK_FUNCTIONS,
  type UncastObject
} from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

import { CustomFunction } from '../operators/customFunction'

const ArgsSchema = z.object({
  fileId: z.string().uuid().describe('The file ID to check against')
})

/**
 * Responsible for matching an input address against an address availability file,
 * which should evaluate true if the input address is contained within the file.
 *
 * This is currently used by AvailabilityCheck block to jump to a specific step in case of a match.
 */
export const availabilityCheckFunction = new CustomFunction<UncastObject>(
  AVAILABILITY_CHECK_FUNCTIONS.AVAILABILITY_CHECK,
  async (factValue, _comparisonValue, _context, args, _signal) => {
    const parsedArgs = ArgsSchema.parse(args)

    const { fileId } = parsedArgs

    return availabilityCheck(fileId, factValue as AvailabilityUserFiltersValue)
  },
  // this check is known for being slow, therefore we need a longer timeout
  15_000
)
